import React from 'react';
import Navigation from '../components/Navigation.jsx';
import Footer from '../components/Footer.jsx';
export default function PathOneEnrollment() {
  return <div className="min-h-screen bg-white">
      <Navigation variant="transparent-to-solid" />
      
      <div className="pt-0 pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-block px-4 py-2 bg-sage-100 text-sage-700 rounded-full text-sm font-medium mb-6">
              Enrollment Open
            </div>
            <h1 className="text-4xl md:text-5xl font-serif font-light text-gray-900 mb-6">
              Join Path One: Coming Home to Yourself
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto">
              A 12-week guided group journey to help you move from self-abandonment to self-trust through nervous system regulation and somatic healing.
            </p>
          </div>

          {/* Two Column Layout */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Program Details */}
            <div className="bg-gradient-to-br from-sage-50 to-warm-50 rounded-2xl p-8 border border-sage-200">
              <h2 className="text-2xl font-serif font-light text-gray-900 mb-6">Program Details</h2>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-sage-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-gray-700"><strong>Duration:</strong> 12 weeks</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-sage-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-gray-700"><strong>Format:</strong> Weekly 2-hour group sessions</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-sage-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-gray-700"><strong>Platform:</strong> Secure video conferencing</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-sage-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-gray-700"><strong>Group Size:</strong> Small, intimate cohort</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-6 h-6 text-sage-600 mr-3 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-gray-700"><strong>Bonus:</strong> Optional midweek support</span>
                </li>
              </ul>
            </div>

            {/* What You'll Gain */}
            <div className="bg-white rounded-2xl p-8 border-2 border-sage-300">
              <h2 className="text-2xl font-serif font-light text-gray-900 mb-6">What You'll Gain</h2>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="text-warm-500 text-xl mr-3 mt-0.5">✓</span>
                  <span className="text-gray-700">Nervous system regulation skills</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-500 text-xl mr-3 mt-0.5">✓</span>
                  <span className="text-gray-700">Tools to release worries and fears</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-500 text-xl mr-3 mt-0.5">✓</span>
                  <span className="text-gray-700">Understanding of your pleasing parts</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-500 text-xl mr-3 mt-0.5">✓</span>
                  <span className="text-gray-700">A safe, supportive community</span>
                </li>
                <li className="flex items-start">
                  <span className="text-warm-500 text-xl mr-3 mt-0.5">✓</span>
                  <span className="text-gray-700">Confidence in your authentic self</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Enrollment Steps */}
          <div className="bg-gradient-to-br from-sage-50 to-white rounded-2xl p-8 md:p-12 border-2 border-sage-200 mb-12">
            <h2 className="text-3xl font-serif font-light text-gray-900 mb-2 text-center">
              Thank you!
            </h2>
            <p className="text-lg text-gray-600 mb-8 text-center">
              Thank you for scheduling your free consult. You will receive an email confirmation shortly.
            </p>
            
            <div className="space-y-8 max-w-2xl mx-auto">
              {/* Step 1 */}
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0 w-12 h-12 bg-sage-600 text-white rounded-full flex items-center justify-center text-xl font-semibold">
                  1
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Schedule Your Interview</h3>
                  <p className="text-gray-600 mb-4">{"Book a free 20-minute consultation so we can explore whether this program feels like the right fit for you at this time. If it doesn\u2019t, I\u2019ll be happy to share referrals that may be more aligned with what you\u2019re looking for.\n"}</p>
                  <a href="https://calendly.com/yphilipos/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-6 py-3 bg-sage-600 text-white rounded-lg hover:bg-sage-700 transition-colors font-medium">
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    Schedule Your Interview
                  </a>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0 w-12 h-12 bg-sage-600 text-white rounded-full flex items-center justify-center text-xl font-semibold">
                  2
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">{"Complete Logistics Regarding Onboarding"}</h3>
                  <p className="text-gray-600 mb-4">{"After your interview, if we both agree it's a good fit, you will receive an email with instructions to secure your spot in the program."}</p>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0 w-12 h-12 bg-sage-600 text-white rounded-full flex items-center justify-center text-xl font-semibold">
                  3
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Begin Your Transformation</h3>
                  <p className="text-gray-600">{"Once enrolled, you\u2019ll receive an onboarding email with all the program details, including links to all 12 sessions and other logistics."}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Questions */}
          <div className="text-center bg-sage-50 rounded-2xl p-8">
            <h3 className="text-2xl font-serif font-light text-gray-900 mb-4">
              Have Questions?
            </h3>
            <p className="text-gray-600 mb-6">
              We're here to help you decide if Path One is right for you.
            </p>
            <a href="mailto:yphilipos@gmail.com" className="inline-flex items-center text-sage-600 hover:text-sage-700 font-medium transition-colors">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email us at yphilipos@gmail.com
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>;
}